import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { fetchEvents } from "@/lib/api";
import { eventTypeMeta, formatEventDate, eventDayParts } from "@/lib/events";
import { MapPin, Globe, ArrowRight, CalendarClock } from "lucide-react";

export default function EventsStrip() {
  const { pick } = useLang();
  const en = pick("", "x") === "x";
  const [events, setEvents] = useState([]);

  useEffect(() => { fetchEvents({ when: "upcoming" }).then((d) => setEvents(d.slice(0, 3))).catch(() => {}); }, []);
  if (events.length === 0) return null;

  return (
    <section className="border-t border-line bg-[var(--surface)]" data-testid="home-events-strip">
      <div className="mx-auto max-w-7xl px-5 py-14 md:px-8 md:py-16">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <p className="overline-label text-gold">{pick("आगामी आयोजन", "Upcoming events")}</p>
            <h2 className="mt-2 flex items-center gap-2 font-serif-latin text-2xl text-ink md:text-3xl"><CalendarClock className="h-6 w-6 text-saffron" /> {pick("कथा, यज्ञ, उत्सव एवं प्रवचन", "Kathas, yagyas, festivals & talks")}</h2>
          </div>
          <Link to="/events" data-testid="home-events-all" className="hidden shrink-0 items-center gap-1.5 text-sm text-saffron hover:underline sm:inline-flex">{pick("सभी आयोजन", "All events")} <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {events.map((e) => {
            const tm = eventTypeMeta(e.type); const dp = eventDayParts(e.start);
            return (
              <Link key={e.id} to={`/events/${e.id}`} data-testid={`home-event-${e.id}`} className="group flex gap-4 border border-line bg-[var(--surface)] p-4 transition-colors hover:border-saffron/50">
                <div className="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded" style={{ backgroundColor: `${tm.accent}14`, color: tm.accent }}>
                  <span className="font-serif-latin text-xl leading-none">{dp.day}</span>
                  <span className="text-[10px] uppercase tracking-wider">{dp.mon}</span>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-[10px] font-medium uppercase tracking-wider" style={{ color: tm.accent }}>{pick(tm.deva, tm.en)}</p>
                  <h3 className="mt-0.5 line-clamp-1 font-serif-latin text-base text-ink transition-colors group-hover:text-saffron">{e.title}</h3>
                  <p className="mt-1 text-xs text-ink-3">{formatEventDate(e.start, en)}</p>
                  <p className="mt-1 flex items-center gap-1 text-xs text-ink-3">
                    {e.mode !== "in_person" ? <><Globe className="h-3 w-3" /> {pick("ऑनलाइन", "Online")}</> : <><MapPin className="h-3 w-3" /> {e.city || e.venue}</>}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
        <Link to="/events" className="mt-6 inline-flex items-center gap-1.5 text-sm text-saffron hover:underline sm:hidden">{pick("सभी आयोजन", "All events")} <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </section>
  );
}
